import React from 'react'
import './ProgressIndicator.css'
import start from './start.svg'
import { useDataContext } from '../../context/DataProvider'

const ProgressIndicator: React.FC<{
  ratio?: number
}> = ({ ratio }) => {
  const { progress } = useDataContext()
  const displayedProgress = Math.max(0, Math.min(ratio ?? progress, 1))

  return (
    <div
      className="progress-bar"
      // style={{'background': 'red'}}
      style={
        { '--progress': `${displayedProgress * 100}%` } as React.CSSProperties
      }
      // style={{'background': `${normalizedProgress*100}%` }}
    >
      {/* dynamic indicator */}
      <div className="invisible-track">
        <div
          className="indicator"
          style={
            {
              '--display': `${
                displayedProgress === 0 || displayedProgress === 1
                  ? 'none'
                  : 'block'
              }`,
            } as React.CSSProperties
          }
        >
          <div
            style={{
              background: `url(${start})`,
              width: 31,
              height: 33,
              aspectRatio: '31/33',
            }}
          />
        </div>
      </div>
      {/* dynamic track */}
      <div className="track-background">
        <div className="track-foreground" />
      </div>
      {/* icons */}
      <div className="start-end">
        <div>
          {displayedProgress === 0 && (
            <div
              style={{
                background: `url(${start})`,
                width: 31,
                height: 33,
                aspectRatio: '31/33',
              }}
            />
          )}
        </div>
        <div className="space" />
        <div>
          {displayedProgress === 1 && (
            <div
              style={{
                background: `url(${start})`,
                width: 31,
                height: 33,
                aspectRatio: '31/33',
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ProgressIndicator
